export default "__VITE_ASSET__syNJvDCJ__"